import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Newspaper } from "lucide-react";
import api from "../lib/api";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { PostCard } from "../sections/BlogPreview";
import { BLOG_CATEGORIES } from "../data/content";
import { stagger, usePageMeta, Reveal } from "../lib/motion";

const BlogPage = () => {
  usePageMeta("Blog", "Immigration insights, documentation guidance and travel tips from The Trip World.");
  const [posts, setPosts] = useState(null);
  const [category, setCategory] = useState("All");

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  const filtered = posts ? (category === "All" ? posts : posts.filter((p) => p.category === category)) : [];

  return (
    <main data-testid="blog-page">
      <PageHero
        eyebrow="THE JOURNAL"
        title="INSIGHTS &"
        highlight="UPDATES"
        description="Guidance, documentation advice and destination insights — written by our own consultancy team."
      />
      <section className="py-20 lg:py-28 bg-navy-deep">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal className="flex flex-wrap gap-3 mb-12" >
            {["All", ...BLOG_CATEGORIES].map((c) => (
              <button
                key={c}
                onClick={() => setCategory(c)}
                data-testid={`blog-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`rounded-full px-5 py-2.5 text-xs font-bold tracking-wider font-display transition-all duration-300 ${
                  category === c ? "btn-gold" : "btn-outline-light"
                }`}
              >
                {c.toUpperCase()}
              </button>
            ))}
          </Reveal>
          {filtered.length > 0 ? (
            <motion.div
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
            >
              {filtered.map((p) => (
                <PostCard key={p.id} post={p} />
              ))}
            </motion.div>
          ) : posts ? (
            <div className="rounded-2xl border border-dashed border-gold/40 bg-gold/[0.03] p-12 text-center max-w-2xl mx-auto" data-testid="blog-empty-state">
              <Newspaper className="h-10 w-10 text-gold mx-auto mb-5" />
              <h3 className="font-display text-xl font-bold text-white mb-3">No articles here yet.</h3>
              <p className="text-sm text-slate-400 leading-relaxed max-w-md mx-auto">
                New articles are published by our team regularly. Check back soon.
              </p>
            </div>
          ) : (
            <div className="h-40" />
          )}
        </div>
      </section>
      <CtaBand />
    </main>
  );
};

export default BlogPage;
